<template>
    <div> </div>
</template>

<script lang="ts"> 
	
    import  LoginService  from '@/service/v1/seguranca/LoginService';

    import { Actions } from "@/store/enums/StoreEnums";  
    import { Options, Vue  } from "vue-class-component";  

    import { namespace } from 'vuex-class';  
    const authStore = namespace('auth');

    @Options({
        name: "Login",
        components: { },  
    }) 
    export default class Login extends Vue {

        private loginService = new LoginService();
 
        @authStore.Action
        public [Actions.LOGOUT]!: (  ) => void
 
        @authStore.Action
        public [Actions.LOGIN]!: ( token ) => Promise<any>
 
        mounted() {  
            if ( this.$route.params.token ) {   
                this[Actions.LOGIN]( this.$route.params.token ).then(() => this.$router.push({ name: "home" })); 
            }
            else{
                console.log('Deu ruim');
            } 
        }
 
    } 
 
</script> 